import React, { useEffect, useMemo, useState } from 'react'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import axios from 'axios'

import './NavNovo.css'
import brasao from '../../assets/crefito.png'

const cx = (...parts) => parts.filter(Boolean).join(' ')

const useMediaQuery = query => {
    const getMatches = () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false)
    const [matches, setMatches] = useState(getMatches)

    useEffect(() => {
        if (typeof window === 'undefined') return
        const mql = window.matchMedia(query)
        const onChange = () => setMatches(mql.matches)

        if (mql.addEventListener) mql.addEventListener('change', onChange)
        else mql.addListener(onChange)

        setMatches(mql.matches)

        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', onChange)
            else mql.removeListener(onChange)
        }
    }, [query])

    return matches
}

const MenuLink = ({ to, icon, children, onClick, right }) => {
    return (
        <NavLink to={to} onClick={onClick} className="navMenuLink" activeClassName="navMenuLinkActive" exact={false}>
            <i className={cx('bi', icon, 'navMenuIcon')} />
            <span className="navMenuText">{children}</span>
            {right ? <span className="navMenuRight">{right}</span> : null}
        </NavLink>
    )
}

const Dropdown = ({ label, className, children, asLinkTo }) => {
    const [open, setOpen] = useState(false)

    if (asLinkTo) {
        return (
            <div className="navDropdown">
                <NavLink to={asLinkTo} className={cx('navItem', className)} activeClassName="navItemActive" exact={false}>
                    {label}
                </NavLink>
            </div>
        )
    }

    return (
        <div
            className={cx('navDropdown', open && 'navDropdownOpen')}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onFocusCapture={() => setOpen(true)}
            onBlurCapture={e => {
                const next = e.relatedTarget
                if (!next || !e.currentTarget.contains(next)) setOpen(false)
            }}
        >
            <button type="button" className={cx('navItem', 'navItemButton', className)} aria-expanded={open}>
                {label}
                <i className="bi bi-chevron-down navChevron" />
            </button>

            <div className="navDropdownBridge" aria-hidden="true" />

            <div className={cx('navMenu', open && 'navMenuOpen')} style={{ top: '100%' }}>
                <div className="navMenuCard">{children}</div>
            </div>
        </div>
    )
}

const MobileAccordion = ({ title, open, onToggle, children }) => {
    return (
        <div className={cx('navMobileGroup', open && 'navMobileGroupOpen')}>
            <button type="button" className="navMobileGroupHeader" onClick={onToggle} aria-expanded={open}>
                <span className="navMobileGroupTitle">{title}</span>
                <i className={cx('bi', open ? 'bi-chevron-up' : 'bi-chevron-down', 'navMobileGroupChevron')} />
            </button>
            <div className={cx('navMobileGroupBody', open && 'navMobileGroupBodyOpen')}>{children}</div>
        </div>
    )
}

export default function Nav() {
    const history = useHistory()
    const location = useLocation()
    const isDesktop = useMediaQuery('(min-width:600px)')

    const usuario = typeof window !== 'undefined' ? localStorage?.nome : ''
    const tipo = typeof window !== 'undefined' ? localStorage?.tipo : ''

    const [qtdMensagem, setQtdMensagem] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [mobileOpen, setMobileOpen] = useState(false)
    const [mobileGroups, setMobileGroups] = useState({
        processos: true,
        rotas: false,
        suporte: false,
        ai: false,
        defis: false
    })

    const ficha = useMemo(() => ({ usuario }), [usuario])

    useEffect(() => {
        const url = '/api/mensagem/getMensagem'
        let cancelled = false

        axios
            .post(url, ficha)
            .then(resp => {
                if (cancelled) return
                const count = Array.isArray(resp?.data?.mensagens) ? resp.data.mensagens.length : 0
                setQtdMensagem(count)
                setLoaded(true)
            })
            .catch(() => {
                if (cancelled) return
                setLoaded(true)
                setQtdMensagem(0)
            })

        return () => {
            cancelled = true
        }
    }, [ficha])

    useEffect(() => {
        setMobileOpen(false)
    }, [location.pathname])

    const logout = () => {
        localStorage.clear()
        history.push('/')
    }

    const processosItems = useMemo(
        () => [
            { to: '/novoEstabelecimento', icon: 'bi-file-earmark-plus', label: 'Adicionar CPF/CNPJ' },
            { to: '/buscaEstabelecimento', icon: 'bi-search', label: 'Pesquisar CPF/CNPJ' },
            { to: '/buscaPafSetor', icon: 'bi-search', label: 'Pesquisar PAF' },
            { to: '/buscaProcesso', icon: 'bi-search', label: 'Pesquisar PAD' },
            { to: '/buscaTerceirizados', icon: 'bi-search', label: 'Empresas Terceirizadas' }
        ],
        []
    )

    const rotasItems = useMemo(() => {
        if (tipo === 'fiscal') {
            return [
                { to: '/novaRota', icon: 'bi-signpost', label: 'Nova Rota' },
                { to: '/minhasRotas', icon: 'bi-signpost-split', label: 'Minhas Rotas' },
                { to: '/rotaNaoRealizada', icon: 'bi-file', label: 'Inserir não Realizada' },
                { to: '/pesquisaNaoRealizada', icon: 'bi-search', label: 'Pesquisar não Realizada' }
            ]
        }

        if (tipo === 'fiscalAssessor') {
            return [
                { to: '/novaRota', icon: 'bi-signpost', label: 'Nova Rota' },
                { to: '/minhasRotas', icon: 'bi-signpost-split', label: 'Minhas Rotas' },
                { to: '/rotaNaoRealizada', icon: 'bi-file', label: 'Inserir não Realizada' },
                { to: '/pesquisaNaoRealizada', icon: 'bi-search', label: 'Pesquisar não Realizada' },
                { to: '/rotasCoord', icon: 'bi-file-bar-graph', label: 'Relatório' }
            ]
        }

        return [
            { to: '/coordRotas', icon: 'bi-signpost-split', label: 'Rotas' },
            { to: '/novaRota', icon: 'bi-signpost', label: 'Nova Rota' },
            { to: '/rotasCoord', icon: 'bi-file-bar-graph', label: 'Relatório' },
            { to: '/rotaNaoRealizada', icon: 'bi-file', label: 'Inserir não Realizada' },
            { to: '/pesquisaNaoRealizada', icon: 'bi-search', label: 'Pesquisar não Realizada' }
        ]
    }, [tipo])

    const suporteItems = useMemo(() => {
        if (tipo === 'interno') {
            return [{ to: '/suporteInterno', icon: 'bi-envelope', label: 'Chamados' }]
        }

        return [
            { to: '/novoChamado', icon: 'bi-envelope-plus', label: 'Novo Chamado' },
            { to: '/meusChamados', icon: 'bi-envelope', label: 'Meus Chamados' }
        ]
    }, [tipo])

    const aiItems = useMemo(
        () => [
            { to: '/ia', icon: 'bi-stars', label: 'IA' },
            { to: '/pesquisaRegistro', icon: 'bi-file-bar-graph', label: 'Consulta Registros' }
        ],
        []
    )

    const defisItems = useMemo(
        () => [
            { to: '/planilhaPE', icon: 'bi-file-earmark-spreadsheet', label: 'Planilha' },
            { to: '/dashPE', icon: 'bi-bar-chart', label: 'Dashboard' }
        ],
        []
    )

    const adminItems = useMemo(() => {
        if (tipo !== 'interno') return []

        return [{ to: '/usuariosAdmin', icon: 'bi-people', label: 'Administração de Usuários' }]
    }, [tipo])

    const showDataAnalysis = tipo !== 'fiscal'
    const mensagemTo = tipo === 'fiscal' || tipo === 'fiscalAssessor' ? '/mensagemFiscal' : '/mensagem'
    const showBadge = tipo === 'fiscal' || tipo === 'fiscalAssessor'

    const toggleGroup = key => {
        setMobileGroups(prev => ({ ...prev, [key]: !prev[key] }))
    }

    if (isDesktop) {
        return (
            <header className="navRoot">
                <nav className="navBar" role="navigation" aria-label="Navegação principal">
                    <NavLink to="/" className="navBrand" aria-label="Início" exact={true}>
                        <img src={brasao} alt="Crefito" className="navBrandLogo" />
                    </NavLink>

                    <div className="navItems">
                        <Dropdown label="Processos" className="navItemWide">
                            {processosItems.map(item => (
                                <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                    {item.label}
                                </MenuLink>
                            ))}
                        </Dropdown>

                        <Dropdown label="Rotas">
                            {rotasItems.map(item => (
                                <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                    {item.label}
                                </MenuLink>
                            ))}
                        </Dropdown>

                        <Dropdown label="Mapa" asLinkTo="/mapa" />

                        <Dropdown label="Suporte">
                            {suporteItems.map(item => (
                                <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                    {item.label}
                                </MenuLink>
                            ))}
                        </Dropdown>

                        <div className="navDropdown">
                            <NavLink to={mensagemTo} className="navItem" activeClassName="navItemActive" exact={false}>
                                Mensagem
                                {showBadge ? (
                                    <span className={cx('navBadge', loaded && qtdMensagem > 0 && 'navBadgePulse')}>{qtdMensagem}</span>
                                ) : null}
                            </NavLink>
                        </div>

                        {showDataAnalysis ? (
                            <Dropdown label="Data Analysis" asLinkTo="/report" className="navItemWide" />
                        ) : null}

                        <Dropdown label="AI & Insights" className="navItemWide">
                            {aiItems.map(item => (
                                <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                    {item.label}
                                </MenuLink>
                            ))}
                        </Dropdown>

                        <Dropdown label="Defis">
                            {defisItems.map(item => (
                                <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                    {item.label}
                                </MenuLink>
                            ))}
                        </Dropdown>

                        {adminItems.length ? (
                            <Dropdown label="Usuários" className="navItemWide">
                                {adminItems.map(item => (
                                    <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                        {item.label}
                                    </MenuLink>
                                ))}
                            </Dropdown>
                        ) : null}
                    </div>

                    <div className="navRight">
                        <button type="button" className="navLogout" onClick={logout}>
                            <i className="bi bi-box-arrow-right navLogoutIcon" />
                            <span className="navLogoutText">Sair</span>
                        </button>
                    </div>
                </nav>
            </header>
        )
    }

    return (
        <header className="navRoot">
            <nav className="navBar navBarMobile" role="navigation" aria-label="Navegação principal">
                <button
                    type="button"
                    className={cx('navMobileToggle', mobileOpen && 'navMobileToggleActive')}
                    onClick={() => setMobileOpen(v => !v)}
                    aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}
                    aria-expanded={mobileOpen}
                >
                    <i className={cx('bi', mobileOpen ? 'bi-x-lg' : 'bi-list', 'navMobileToggleIcon')} />
                </button>

                <NavLink to="/" className="navBrand navBrandMobile" aria-label="Início" exact={true}>
                    <img src={brasao} alt="Crefito" className="navBrandLogo navBrandLogoMobile" />
                </NavLink>

                <button type="button" className="navLogout navLogoutMobile" onClick={logout} aria-label="Sair">
                    <i className="bi bi-box-arrow-right navLogoutIcon" />
                </button>
            </nav>

            <div className={cx('navMobileDrawer', mobileOpen && 'navMobileDrawerOpen')}>
                <div className="navMobileCard">
                    <MobileAccordion title="Processos" open={!!mobileGroups.processos} onToggle={() => toggleGroup('processos')}>
                        {processosItems.map(item => (
                            <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                {item.label}
                            </MenuLink>
                        ))}
                    </MobileAccordion>

                    <MobileAccordion title="Rotas" open={!!mobileGroups.rotas} onToggle={() => toggleGroup('rotas')}>
                        {rotasItems.map(item => (
                            <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                {item.label}
                            </MenuLink>
                        ))}
                    </MobileAccordion>

                    <div className="navMobileDivider" />

                    <MenuLink to="/mapa" icon="bi-map">
                        Mapa
                    </MenuLink>

                    <MenuLink
                        to={mensagemTo}
                        icon="bi-chat-left-text"
                        right={showBadge ? <span className="navBadge navBadgeInline">{qtdMensagem}</span> : null}
                    >
                        Mensagem
                    </MenuLink>

                    {showDataAnalysis ? (
                        <MenuLink to="/report" icon="bi-graph-up">
                            Data Analysis
                        </MenuLink>
                    ) : null}

                    <div className="navMobileDivider" />

                    <MobileAccordion title="Suporte" open={!!mobileGroups.suporte} onToggle={() => toggleGroup('suporte')}>
                        {suporteItems.map(item => (
                            <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                {item.label}
                            </MenuLink>
                        ))}
                    </MobileAccordion>

                    <MobileAccordion title="AI & Insights" open={!!mobileGroups.ai} onToggle={() => toggleGroup('ai')}>
                        {aiItems.map(item => (
                            <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                {item.label}
                            </MenuLink>
                        ))}
                    </MobileAccordion>

                    <MobileAccordion title="Defis" open={!!mobileGroups.defis} onToggle={() => toggleGroup('defis')}>
                        {defisItems.map(item => (
                            <MenuLink key={item.to} to={item.to} icon={item.icon}>
                                {item.label}
                            </MenuLink>
                        ))}
                    </MobileAccordion>

                    {adminItems.length ? (
                        <MenuLink to="/usuariosAdmin" icon="bi-people">
                            Usuários
                        </MenuLink>
                    ) : null}

                    <div className="navMobileFooter">
                        <button type="button" className="navLogout navLogoutMobileFooter" onClick={logout}>
                            <i className="bi bi-box-arrow-right navLogoutIcon" />
                            <span className="navLogoutText">Sair</span>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    )
}